import { Component } from "@angular/core";
import { MdDialogRef } from "@angular/material";

@Component({
  selector: "confirm-email-sent",
  template: require("./confirm-email-sent-dialog.component.html"),
  styles: [require("./confirm-email-sent-dialog.component.scss")]
})
export class ConfirmEmailSentDialogComponent {
  public mail: string;

  public constructor(
    public dialog: MdDialogRef<ConfirmEmailSentDialogComponent>
  ) {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/login/confirm-email-sent-dialog/confirm-email-sent-dialog.component.ts